import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57646b5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { ref, defineAsyncComponent, onMounted } from 'vue'
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import { getBannerApi } from '@/api/common'
import checkPc from '@/utils/checkPc'

/**
 * 判断是否PC端
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const modules = [Autoplay];
const isPC = checkPc()

// 引入组件
const BotherView = defineAsyncComponent(() => import('./components/Bother.vue'));
const PdfView = defineAsyncComponent(() => import('./components/Pdf.vue'));
const EncryptionView = defineAsyncComponent(() => import('./components/Encryption.vue'));
const ContentView = defineAsyncComponent(() => import('./components/Content.vue'));

const bannerList = ref([])

// 获取首页轮播图
const getBannerList = async () => { 
  const res:any = await getBannerApi()
  bannerList.value = res
}

onMounted(() => {
  getBannerList()
})


return (_ctx: any,_cache: any) => {
  const _component_my_button = _resolveComponent("my-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (bannerList.value.length > 0)
      ? (_openBlock(), _createBlock(_unref(Swiper), {
          key: 0,
          "slides-per-view": 1,
          "space-between": 0,
          speed: 500,
          loop: true,
          modules: modules,
          autoplay: { delay: 3000, disableOnInteraction: false }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_unref(isPC))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: item.image,
                          alt: ""
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: item.image_s || item.image,
                          alt: ""
                        }, null, 8, _hoisted_3)),
                    _createVNode(_component_router_link, {
                      class: "link-btn",
                      to: "/pdf/index"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_my_button, { text: "笔熊分享" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(BotherView)),
    _createVNode(_unref(PdfView)),
    _createVNode(_unref(EncryptionView)),
    _createVNode(_unref(ContentView))
  ]))
}
}

})